import React, { useState } from "react";
import { useFetch } from "../../lib/useFetch";
import { useAuth } from "../../lib/auth";
import { Plus } from "lucide-react";
import UserRow from "./UserRow";
import UserProfileDialog from "./UserProfileDialog";
import UserStatsDialog from "./UserStatsDialog";
import ReviewDialog from "./ReviewDialog";
import OrderDialog from "./OrderDialog";

export default function UsersPanel() {
  const { user: me } = useAuth();
  const isOwner = me.role_level >= 10;
  const [data, reload] = useFetch("/admin/users");
  const [dialog, setDialog] = useState(null);
  const close = () => setDialog(null);
  const done = () => { setDialog(null); reload(); };
  const users = data?.users || [];

  return (
    <div className="glass rounded-2xl p-6" data-testid="panel-users">
      <div className="flex items-center justify-between flex-wrap gap-3 mb-4">
        <h3 className="font-heading text-2xl font-bold">👥 Пользователи ({users.length})</h3>
        {isOwner && (
          <button onClick={() => setDialog({ type: "profile", user: null })} className="btn-gold !py-2 inline-flex items-center gap-2" data-testid="user-add-btn">
            <Plus size={14} /> Пользователь
          </button>
        )}
      </div>
      {!isOwner && <p className="text-xs text-gray-500 mb-4">Режим просмотра — изменения доступны только владельцу.</p>}
      <div className="space-y-3">
        {users.map((u) => <UserRow key={u.id} u={u} isOwner={isOwner} onOpen={(type) => setDialog({ type, user: u })} onChanged={reload} />)}
      </div>
      {dialog?.type === "profile" && <UserProfileDialog user={dialog.user} onClose={close} onSaved={done} />}
      {dialog?.type === "stats" && <UserStatsDialog user={dialog.user} canDelete={me.role_level >= 7} onClose={close} onChanged={reload} />}
      {dialog?.type === "order" && <OrderDialog presetUser={dialog.user} onClose={close} onSaved={done} />}
      {dialog?.type === "review" && <ReviewDialog user={dialog.user} onClose={close} onSaved={done} />}
    </div>
  );
}
